import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AdminTasApprovalQueueController extends Controller {
  @service declare store: StoreService;

  @tracked order = 'attention_priority_date';
  @tracked approval: string | null = '';
  @tracked program: string | null = '';
  @tracked search = '';
  @tracked page = 1;
  @tracked limit = 25;
  @tracked loading = false;
  @tracked disableReviewer = false;
  @tracked waitingOnOthers = false;

  queryParams = [
    'order',
    'approval',
    'program',
    'search',
    'page',
    'limit',
    'disableReviewer',
    'waitingOnOthers',
  ];

  clearQueryParams = () => {
    this.order = 'attention_priority_date';
    this.approval = '';
    this.program = '';
    this.search = '';
    this.page = 1;
    this.limit = 25;
    this.disableReviewer = false;
    this.waitingOnOthers = false;
  };
}
